import constants from '@/constants'
import DateManager from '@/logic/DateManager'

export default {
  appointments: null,
  deadlineNow: DateManager.now().getTime(),
  searchQuery: '',
  filter: constants.APPOINTMENTS.FILTER_UPCOMING,
  sort: constants.APPOINTMENTS.SORT_RELEVANT,
  activeCategoryFilters: [],
  searchOpen: false,
}
